import api from './api';

const especialidadService = {
  // Obtener todas las especialidades
  getEspecialidades: async () => {
    try {
      const response = await api.get('/especialidades');
      return response;
    } catch (error) {
      console.error('Error obteniendo especialidades:', error);
      throw error;
    }
  },

  // Obtener especialidad por ID
  getEspecialidad: async (id) => {
    try {
      const response = await api.get(`/especialidades/${id}`);
      return response;
    } catch (error) {
      console.error(`Error obteniendo especialidad ${id}:`, error);
      throw error;
    }
  },

  // Crear especialidad
  createEspecialidad: async (data) => {
    try {
      const response = await api.post('/especialidades', data);
      return response;
    } catch (error) {
      console.error('Error creando especialidad:', error);
      throw error;
    }
  },

  // Actualizar especialidad
  updateEspecialidad: async (id, data) => {
    try {
      const response = await api.put(`/especialidades/${id}`, data);
      return response;
    } catch (error) {
      console.error(`Error actualizando especialidad ${id}:`, error);
      throw error;
    }
  },

  // Eliminar especialidad
  deleteEspecialidad: async (id) => {
    try {
      const response = await api.delete(`/especialidades/${id}`);
      return response;
    } catch (error) {
      console.error(`Error eliminando especialidad ${id}:`, error);
      throw error;
    }
  },
  
  // Obtener especialistas por especialidad
  getEspecialistasByEspecialidad: async (id) => {
    try {
      const response = await api.get(`/especialidades/${id}/especialistas`);
      return response;
    } catch (error) {
      console.error(`Error obteniendo especialistas para especialidad ${id}:`, error);
      throw error;
    }
  },
  
  // Obtener etapas por especialidad
  getEtapasPorEspecialidad: async (especialidadId) => {
    try {
      const response = await api.get(`/especialidades/${especialidadId}/etapas`);
      return response;
    } catch (error) {
      console.error(`Error obteniendo etapas para especialidad ${especialidadId}:`, error);
      throw error;
    }
  }
};

export default especialidadService;